
import * as actionTypes from './actionTypes';

export const initMobileHomeStart = () => {
  return {
    type: actionTypes.INIT_MOBILE_HOME_START
  };
};
export const refreshMobileHome = () => {
  return window.location.reload();
};
export const setMobileHome = (realMobileHome) => {
  // console.log('SET MOBILE HOME', realMobileHome)
  return {
    type: actionTypes.SET_MOBILE_HOME,
    realMobileHome:realMobileHome
  };
};

export const fetchMobileHomeFailed = () => {
  return {
    type: actionTypes.FETCH_MOBILE_HOME_FAILED
  };
};

export const initMobileHome = () => {
  // console.log('INIT MOB ACTIONS')

  return {
    type: actionTypes.INIT_MOBILE_HOME
  };
};
export const changeMobileHome = (enabled) => {
  return {
    type: actionTypes.CHANGE_MOBILE_HOME,
    enabled:enabled
  };
}
export const changeMobileHomeFailed = (errorStatus) => {
  return {
    type: actionTypes.CHANGE_MOBILE_HOME_FAILED,
    errorStatus: errorStatus
  }
}
export const changeMobileHomeSuccess = () => {
  return {
    type: actionTypes.CHANGE_MOBILE_HOME_SUCCESS
  }
}
export const resetMobileHomeErrorSuccess = () => {

  return {
    type: actionTypes.RESET_MOBILE_HOME_ERROR_SUCCESS
  }
}


